import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { SymbolQuotesAction } from './symbolQuotes.action';
import { clientQuoteKey, lpQuoteKey, symbolQuotesInitialState } from './symbolQuotes.constant';
import { ISymbolQuotesStore } from './symbolQuotes.interface';

export const symbolQuotesReducer = reducerWithInitialState(symbolQuotesInitialState)
  .case(SymbolQuotesAction.loadServerSymbols.started, (state): ISymbolQuotesStore => ({
    ...state,
    serverSymbols: { ...state.serverSymbols, networkStatus: NetworkStatus.Started },
  }))
  .case(SymbolQuotesAction.loadServerSymbols.done, (state, { result }): ISymbolQuotesStore => ({
    ...state,
    serverSymbols: { items: result.items, total: result.total, networkStatus: NetworkStatus.Done },
  }))
  .case(SymbolQuotesAction.loadServerSymbols.failed, (state): ISymbolQuotesStore => ({
    ...state,
    serverSymbols: { ...state.serverSymbols, networkStatus: NetworkStatus.Failed },
  }))
  .case(SymbolQuotesAction.loadLpSymbols.started, (state): ISymbolQuotesStore => ({
    ...state,
    lpSymbols: { ...state.lpSymbols, networkStatus: NetworkStatus.Started },
  }))
  .case(SymbolQuotesAction.loadLpSymbols.done, (state, { result }): ISymbolQuotesStore => ({
    ...state,
    lpSymbols: { items: result.items, total: result.total, networkStatus: NetworkStatus.Done },
  }))
  .case(SymbolQuotesAction.loadLpSymbols.failed, (state): ISymbolQuotesStore => ({
    ...state,
    lpSymbols: { ...state.lpSymbols, networkStatus: NetworkStatus.Failed },
  }))
  .case(SymbolQuotesAction.clearSymbols, (state): ISymbolQuotesStore => ({
    ...state,
    serverSymbols: { ...symbolQuotesInitialState.serverSymbols },
    lpSymbols: { ...symbolQuotesInitialState.lpSymbols },
  }))
  .case(SymbolQuotesAction.connectionStateChanged, (state, { state: connectionState }): ISymbolQuotesStore => ({
    ...state,
    connectionState,
  }))
  .case(SymbolQuotesAction.ingestClientQuotes, (state, { quotes }): ISymbolQuotesStore => {
    const clientQuotes = { ...state.clientQuotes };
    for (const quote of quotes) {
      clientQuotes[clientQuoteKey(quote.symbol)] = quote;
    }
    return { ...state, clientQuotes };
  })
  .case(SymbolQuotesAction.ingestLpQuotes, (state, { quotes }): ISymbolQuotesStore => {
    const lpQuotes = { ...state.lpQuotes };
    for (const quote of quotes) {
      lpQuotes[lpQuoteKey(quote)] = quote;
    }
    return { ...state, lpQuotes };
  })
  .case(SymbolQuotesAction.disconnect, () => ({ ...symbolQuotesInitialState }));
